import React from "react";
import "./ProfileMembers.css";
import aboutSunilBabu from "../../../Images/sunilbabutext.webp";
import SunilbabuHero from "../../../Images/SunilbabuHeroImage.webp";

function ProfileMembers() {
  return (
    <>
      <div className="m-profiles-hero">
        <img src={SunilbabuHero} alt="" />
      </div>

      <div className="sunilBabu">
        <div className="SunilbabuImage">
          <img src={aboutSunilBabu} alt="" />
        </div>
        <div className="aboutSunilBabu">
          <div className="sunilBabuText">
            <p>
              Sunil Babu has Over 45 years of Cricketing Experience as a
              Professional Cricketer, former County Cricketer, UK, Coach,
              Cricket Analyst and Administrator. He worked as Board member of
              National School Cricket Council, under the Chairmanship of ex
              Indian cricket legend Chetan Sharma (Present Chief Selector,
              BCCI), also worked as Mentor for South India for JCC, Chetan
              Sharma, Ashok Malhotra and Surendra Khanna other Zonal mentors of
              JCC. Sunil babu is the founder-secretary of CAT, Cricket
              Association of Telangana, since 2011, founder of TSPL, Telangana
              Schools Premier League, India’s first Premier league for Schools,
              TSPL is Mentored by former Indian Cricket Captain and two-time
              BCCI Chief Selector, Legendary Dilip Vengsarkar. Working towards
              the development of Schools Cricket for all new ICC affiliated
              countries which are struggling to launch the sport in the
              respective regions. Sunil babu working to create level playing
              field for the Rural Cricket Talent in his State since 2011.
              Founder of ISTL, Indian Schools Talent League. Sunil Babu is also
              doing school cricket projects in the USA.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileMembers;
